import type { WPrezentationCardsTranslations } from "./pl";

export const de: WPrezentationCardsTranslations = {
  empty: "Keine Slides zum Anzeigen.",
  cta: "Mehr ansehen",
  openSlideAria: "Öffnen",
  youtubeTitleFallback: "YouTube-Video",
};
